import Vue, { watch, unref, ref, onUnmounted } from 'vue'
import { Vuelidate } from '@/scripts/app-configs/vuelidate-config.js'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useLegacyVuelidate(rules: any, formStatus: any) {

  // @ts-expect-error: Ignore legacy Vue warn. Constructor to be mocked below on `beforeCreate` hook
  Vue.use(Vuelidate)

  // @ts-expect-error: Again, ignore as it is a transition warning
  const vm = new Vue({
    data() {
      return unref(formStatus)
    },
    beforeCreate() {
      if (!('constructor' in this)) {
        Object.defineProperty(this, 'constructor', {
          configurable: true,
          enumerable: false,
          writable: true,
          value: Vue,
        })
      }
    },
    validations() {
      return unref(rules)
    },
    methods: {
      setData(newFormStatus: object) {
        Object.entries(newFormStatus).forEach(([prop, val]) => {
          // @ts-expect-error Not relevant
          this[prop] = val
        })
      },
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(h: any) { return h('div') },
  }).$mount(document.createElement('div'))

  const vuelidate = ref(vm.$v)

  watch(() => formStatus, () => vm.setData(unref(formStatus)), { deep: true })
  watch(() => rules, () => vuelidate.value = vm.$v, { deep: true })

  onUnmounted(() => {
    vm.$destroy()
  })

  return vuelidate
}
